import React from 'react'

const SuccessCheck = () => (
  <svg
    width="68"
    height="68"
    viewBox="0 0 68 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.0001 0.666992C52.4101 0.666992 67.3334 15.5903 67.3334 34.0003C67.3334 52.4103 52.4101 67.3337 34.0001 67.3337C15.5901 67.3337 0.666748 52.4103 0.666748 34.0003C0.666748 15.5903 15.5901 0.666992 34.0001 0.666992ZM44.7334 23.9003L29.8334 38.8003L23.2667 32.2337C22.7928 31.7921 22.166 31.5516 21.5183 31.5631C20.8707 31.5745 20.2527 31.8369 19.7947 32.2949C19.3366 32.753 19.0743 33.3709 19.0628 34.0186C19.0514 34.6663 19.2918 35.2931 19.7334 35.767L28.0667 44.1003C28.5355 44.5685 29.1709 44.8315 29.8334 44.8315C30.4959 44.8315 31.1313 44.5685 31.6001 44.1003L48.2668 27.4337C48.5124 27.2048 48.7094 26.9288 48.846 26.6221C48.9827 26.3155 49.0561 25.9844 49.0621 25.6487C49.068 25.3131 49.0062 24.9796 48.8805 24.6683C48.7548 24.357 48.5676 24.0743 48.3302 23.8369C48.0928 23.5995 47.81 23.4123 47.4987 23.2866C47.1874 23.1608 46.854 23.0991 46.5183 23.105C46.1827 23.1109 45.8516 23.1844 45.545 23.3211C45.2383 23.4577 44.9623 23.6547 44.7334 23.9003Z"
      fill="#EF8658"
    />
  </svg>
)

export default SuccessCheck
